{
	"hooks": {
		"exportAllSalesFromEmployee": {
			"date": "Date",
			"filename": "{{employeeName}}-ventes-uniques",
			"filenameEvent": "-à-l'événement-{{eventName}}",
			"filenamePeriod": "-du-{{since}}-au-{{until}}",
			"isRefunded": "Est remboursé",
			"method": "Méthode",
			"refundedAt": "Remboursé le",
			"refundedBy": "Remboursé par",
			"title": "Ventes uniques de {{employeeName}} ",
			"titleEvent": "à l'événement {{eventName}} ",
			"titlePeriod": "de {{since}} au {{until}}",
			"value": "Montant"
		},
		"exportSalesByEmployee": {
			"employee": "Employé",
			"filename": "ventes-uniques-par-employé-",
			"filenameEvent": "à-l'événement-{{eventName}}",
			"filenamePeriod": "-du-{{since}}-au-{{until}}",
			"title": "Ventes uniques par employé ",
			"titleEvent": "à l'événement {{eventName}} ",
			"titlePeriod": "du {{since}} au {{until}}"
		}
	},
	"parseOpenSaleMethod": {
		"credit": "Crédit",
		"debit": "Débit",
		"pix": "Pix",
		"creditInInstallments": "Zig Crédit en versements",
		"integratedFoodVoucher": "Ticket Restaurant"
	}
}
